import {
  forwardRef,
  ForwardRefRenderFunction,
  InputHTMLAttributes,
  useEffect,
  useImperativeHandle,
  useRef,
} from 'react';
import { twJoin } from 'tailwind-merge';

type ElementAttributes = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'children'
>;

export type InputFieldInputProps = ElementAttributes;

const InputFieldInputRenderFunction: ForwardRefRenderFunction<
  HTMLInputElement,
  InputFieldInputProps
> = (props, forwardedRef) => {
  const ref = useRef<HTMLInputElement>(null);

  useImperativeHandle<HTMLInputElement | null, HTMLInputElement | null>(
    forwardedRef,
    () => ref.current,
  );

  useEffect(() => {
    ref.current?.setCustomValidity('');
  }, []);

  return (
    <input
      {...props}
      ref={ref}
      className={twJoin(
        'box-border w-full appearance-none font-[inherit]',
        'block rounded-md border border-stroke-secondary-40 bg-surface-white p-4',
        'text-marine-high-emphasis',
        'focus:outline-none focus-visible:shadow-focus-state',
        'invalid:border-stroke-error-100 invalid:text-error-100 focus-visible:invalid:border-stroke-error-100',
        'disabled:border-transparent disabled:text-marine-medium-emphasis',
        'read-only:border-transparent read-only:text-marine-medium-emphasis',
        'read-only:bg-surface-secondary-7 disabled:bg-surface-secondary-7',
        props.className,
      )}
    />
  );
};

export const InputFieldInput = forwardRef<
  HTMLInputElement,
  InputFieldInputProps
>(InputFieldInputRenderFunction);
